'use strict';require('../../style/css');
require('../../list/style/css');
require('./index.css');


//////////////////
// WEBPACK FOOTER
// ./~/antd-mobile/lib/input-item/style/css.web.js
// module id = 269
// module chunks = 0